// extracted by mini-css-extract-plugin
module.exports = {"ghost":"_08803c3","icon":"_cf6c25c","disabled":"_b707590"};